import { gtm } from '@helpers/dataLayer';
import PerfectMatch from '@img/logos/brand/perfect-match.svg';
import { RootState } from '@state/ducks';
import Button from '@stories/Elements/Forms/Buttons/Button';
import Link from '@stories/Elements/Forms/Buttons/Link';
import React, { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { PerfectMatchCardStyles as S } from './PerfectMatchCard.styles';

export interface PerfectMatchCardProps {
  translations: Record<string, string | undefined>;
  storeLocatorUrl?: string | null;
  accessoryPage?: string | null;
  product?: ProductViewModel;
}

const PerfectMatchCard: FunctionComponent<PerfectMatchCardProps> = (props) => {
  const categories = useSelector((x: RootState) => x.productDetail.categories);
  const variants = useSelector((x: RootState) => x.productDetail.variants);
  const selectedVariant = useSelector((x: RootState) => x.productDetail.selectedVariantAgilityId);

  const chosenVariant = variants?.find((variant) => variant.agilityId === selectedVariant);

  return (
    <S.Card>
      <S.Header>
        <PerfectMatch />
      </S.Header>
      <S.Body>
        <S.Title>{props.translations['custom.productsuggestions.perfectmatch.title']}</S.Title>
        <S.Description>{props.translations['custom.productsuggestions.perfectmatch.description']}</S.Description>
        <S.SubTitle>{props.translations['custom.productsuggestions.perfectmatch.footer']}</S.SubTitle>

        {props.storeLocatorUrl && props.translations['wheretobuy'] && (
          <Button
            theme="green"
            icon="location"
            iconPlacement="before"
            text={props.translations['wheretobuy']}
            onClick={(e) => {
              e.preventDefault();

              if (!props.storeLocatorUrl) {
                return;
              }

              if (props.product) {
                const [item_category, item_category2, item_category3, item_category4, item_category5] =
                  categories ?? [];
                gtm({
                  event: 'click_to_store_locator',
                  item_name: props.product.modelCode,
                  item_variant: chosenVariant ? chosenVariant.name : '',
                  item_category,
                  item_category2,
                  item_category3,
                  item_category4,
                  item_category5,
                  item_id: chosenVariant ? chosenVariant.articleNumber ?? '' : '',
                });
                window.location.href = props.storeLocatorUrl;
              }

              window.location.href = props.storeLocatorUrl;
            }}
          />
        )}
        {props.accessoryPage && (
          <>
            <S.AccessoriesText>
              {props.translations['custom.productsuggestions.browseaccessories.text']}
            </S.AccessoriesText>
            <Link
              theme="black"
              text={props.translations['custom.productsuggestions.browseaccessories.cta']}
              href={props.accessoryPage}
            />
          </>
        )}
      </S.Body>
    </S.Card>
  );
};

export default PerfectMatchCard;
